import React, { useState } from "react";
import { CContainer } from '@coreui/react'
import { useNavigate } from 'react-router-dom'
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";

import './style.css';

import connectorsData from './data/connectors.json';

import azureLogo from '../../assets/images/azure-logo.png';
import awsLogo from '../../assets/images/aws-logo.png';
import gcpLogo from '../../assets/images/gcp-logo.png';

const connectorImages = {
  'azure-logo.png': azureLogo,
  'aws-logo.png': awsLogo,
  'gcp-logo.png': gcpLogo,
};

const getInitials = (name) => {
  const words = name.split(' ').filter(Boolean);
  return ((words[0]?.[0] || '') + (words[1]?.[0] || '')).toUpperCase();
};

const groupByCategory = (connectors) => {
  const groups = [];
  const groupsByName = {};

  connectors.forEach(connector => {
    const category = connector.category || 'Other';
    if (!groupsByName[category]) {
      groupsByName[category] = { category, connectors: [] };
      groups.push(groupsByName[category]);
    }
    groupsByName[category].connectors.push(connector);
  });

  return groups;
};

const ConnectorCard = ({ connector, onConfigure }) => {

  const image = connectorImages[connector.image];

  return (
    <div style={{
      width: '15.5%', minWidth: 220, display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      margin: '1%', background: 'linear-gradient(135deg, #161c2a, #1a2130)', borderRadius: 15
    }}>

      <div style={{ padding: 20 }}>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

          {image ? (
            <img src={image} alt={connector.name} style={{ width: 32, height: 32, objectFit: 'contain' }} />
          ) : (
            <div style={{
              width: 32, height: 32, borderRadius: 6, backgroundColor: connector.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: 12, fontWeight: 'bold'
            }}>
              {getInitials(connector.name)}
            </div>
          )}

          <span style={{ color: '#fff', fontSize: 14, fontWeight: 'bold', marginLeft: 10 }}>
            {connector.name}
          </span>

        </div>

        <span style={{ color: '#8a8fa3', fontSize: 11, marginTop: 10, display: 'block' }}>
          {connector.publisher}
        </span>

      </div>

      <button
        onClick={() => onConfigure(connector)}
        style={{
          border: 'none', borderTop: '1px solid #2a3142', backgroundColor: 'transparent',
          color: '#5b9bd5', fontSize: 12, fontWeight: 'bold', padding: '12px 20px',
          textAlign: 'left', cursor: 'pointer'
        }}>
        CONFIGURE
      </button>

    </div>
  );
};

const CategorySection = ({ category, connectors, expanded, onToggle, onConfigure }) => {

  return (
    <div style={{ width: '100%', marginTop: 20 }}>

      <button
        onClick={onToggle}
        style={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%',
          background: 'linear-gradient(135deg, #1a2130, #202840)', border: 'none', borderRadius: 10,
          padding: '12px 20px', cursor: 'pointer'
        }}>

        {expanded ?
          <MdKeyboardArrowDown size={22} color="#fff" /> :
          <MdKeyboardArrowRight size={22} color="#fff" />
        }

        <span style={{ color: '#fff', fontSize: 15, fontWeight: 'bold', marginLeft: 8 }}>
          {category}
        </span>

        <span style={{ color: '#8a8fa3', fontSize: 12, marginLeft: 10 }}>
          ({connectors.length})
        </span>

      </button>

      {expanded &&
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', marginTop: 10 }}>

          {connectors.map(connector => (
            <ConnectorCard key={connector.id} connector={connector} onConfigure={onConfigure} />
          ))}

        </div>
      }

    </div>
  );
};

const Connectors = () => {

  const navigate = useNavigate();

  const categoryGroups = groupByCategory(connectorsData);

  const [expandedCategories, setExpandedCategories] = useState(
    categoryGroups.reduce((acc, group) => ({ ...acc, [group.category]: true }), {})
  );

  const goToConfigure = (connector) => {
    navigate('/configure-connector?connectorId=' + connector.id);
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({ ...prev, [category]: !prev[category] }));
  };

  const allExpanded = categoryGroups.every(group => expandedCategories[group.category]);

  const toggleAll = () => {
    setExpandedCategories(
      categoryGroups.reduce((acc, group) => ({ ...acc, [group.category]: !allExpanded }), {})
    );
  };

  return (
    <CContainer style={{ marginBottom: 50 }}>

      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

        <h4>Connectors</h4>

        <button
          onClick={toggleAll}
          style={{
            border: '1px solid #fff', borderRadius: 5, background: 'transparent',
            color: '#fff', fontSize: 13, fontWeight: 'bold', padding: '8px 16px', cursor: 'pointer'
          }}>
          {allExpanded ? 'Collapse All' : 'Expand All'}
        </button>

      </div>

      {categoryGroups.map(group => (
        <CategorySection
          key={group.category}
          category={group.category}
          connectors={group.connectors}
          expanded={!!expandedCategories[group.category]}
          onToggle={() => toggleCategory(group.category)}
          onConfigure={goToConfigure}
        />
      ))}

    </CContainer>
  );
};

export default Connectors;
